import axiosPost from "../axiosPost";

export const accesoUpd = async ({
    gateLugarId,
    gateZonaId,
    gateLugarNombre,
    gateLugarCalle,
    localidadId,
    gateLugarCasa,
    gateLugarUnidad,
    gateLugarPiso,
    gateLugarMinimo,
    gateLugarMaximo,
    gateLugarLatitud,
    gateLugarLongitud,
    gateLugarRadio,
    gateLugarVersion,
    gateLugarCod
}, credentials) => {
    const body = {
        service: "GateLugarUpd",
        params: {
            gateLugarId,
            gateZonaId,
            gateLugarNombre,
            gateLugarCalle,
            localidadId,
            gateLugarCasa,
            gateLugarUnidad,
            gateLugarPiso,
            gateLugarMinimo,
            gateLugarMaximo,
            gateLugarLatitud,
            gateLugarLongitud,
            gateLugarRadio,
            gateLugarVersion,
            gateLugarCod
        },
    };

    return await axiosPost(body, credentials);
};
